module.exports = __webpack_public_path__ + "static/media/React-App11.b435964b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/React-App11.png
// module id = 42
// module chunks = 0